export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
